import api from './api';

export interface ProtocolSignatory {
  id?: number;
  name: string;
  position: string;
  signature_image?: string | null;
  signature_image_url?: string | null;
  is_active: boolean;
  is_default: boolean;
  created_at?: string;
  updated_at?: string;
}

export default {
  getAll(params?: any) {
    return api.get('/protocol-signatories', { params });
  },
  getActive() {
    return api.get('/protocol-signatories/active');
  },
  getById(id: number | string) {
    return api.get(`/protocol-signatories/${id}`);
  },
  create(data: FormData) {
    return api.post('/protocol-signatories', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  update(id: number | string, data: FormData) {
    data.append('_method', 'PUT');
    return api.post(`/protocol-signatories/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  delete(id: number | string) {
    return api.delete(`/protocol-signatories/${id}`);
  },
  toggleActive(id: number | string) {
    return api.post(`/protocol-signatories/${id}/toggle-active`);
  },
  setDefault(id: number | string) {
    return api.post(`/protocol-signatories/${id}/set-default`);
  }
};
